module.exports = __webpack_public_path__ + "static/media/youtube.c9b44063.svg";